// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"OfsIsDispatched_checkbox-container__3Fccb","button":"OfsIsDispatched_button__3aETc","center":"OfsIsDispatched_center__2BBsS"};